import React from "react";
import PropTypes from "prop-types";
import InfoAlert from "../Alert/InfoAlert";

const CallDone = ({ callStatus }) => (
  <React.Fragment>
    <InfoAlert block>{callStatus}</InfoAlert>
  </React.Fragment>
);

CallDone.propTypes = {
  callStatus: PropTypes.string.isRequired,
};

export default CallDone;
